var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptionSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 L2,0 C0.9,0 0,0.9 0,2 L0,16 C0,17.1 0.9,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 Z M7.71,13.29 C7.32,13.68 6.69,13.68 6.3,13.29 L2.71,9.7 C2.52274733,9.51316847 2.41751439,9.25951764 2.41751439,8.995 C2.41751439,8.73048236 2.52274733,8.47683153 2.71,8.29 C3.1,7.9 3.73,7.9 4.12,8.29 L7,11.17 L13.88,4.29 C14.27,3.9 14.9,3.9 15.29,4.29 C15.68,4.68 15.68,5.31 15.29,5.7 L7.71,13.29 Z",
    id: "checkbox-selected"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP---02.1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Register---Step-2",
    transform: "translate(-378.000000, -463.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(343.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input-/-Checkbox",
    transform: "translate(35.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checkbox_selected",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-checkbox-selected",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkbox-selected"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon/toggle/check_box_24px",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Color",
    mask: "url(#mask-checkbox-selected)",
    fill: "#dcaa4e"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.000000, -3.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionSelected);
export default __webpack_public_path__ + "static/media/option-selected.b474806c.svg";
export { ForwardRef as ReactComponent };